
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kortlar",
      function () {
        return require("private-next-pages/kortlar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kortlar"])
      });
    }
  